import "./LinearProgress.css";

const LinearProgress = () => {
  return (
    <main>
      <div className="loading-bar-container">
        <div className="loading-bar" />
      </div>
    </main>
  );
};

export default LinearProgress;
